import React, {Fragment, useCallback} from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import IntegrationCard from './IntegrationCard';

/** An Integration category, including the category title and cards */
const IntegrationCardCategory = styled.div``;

/** The integration category's title */
const CategoryTitle = styled.div`
  display: flex;
  margin-bottom: 15px;
  margin-top: 20px;
`;

/** The name of the Integration category */
const CategoryName = styled.h4`
  font-size: 24px;
`;

/** The grid of Integration cards */
const IntegrationCardGrid = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

/** Metadata for the integrations, organized by category. */
const availableIntegrationsByCategory = {
  'CMS': {
    'aem': {
      title: 'Adobe Experience Manager',
      description: 'Push story content directly to AEM',
    },
    'custom': {
      title: 'Custom CMS',
      description: 'Push story content directly to your CMS',
      testable: true,
    },
    'drupal': {
      title: 'Drupal',
      description: 'Push story content directly to Drupal',
      testable: true,
    },
    'wordpress': {
      title: 'WordPress',
      description: 'Push story content directly to WordPress',
      testable: true,
    },
  },
  'Social': {
    'facebook': {
      title: 'Facebook',
      description: 'Post content directly to Facebook',
    },
    'linkedin': {
      title: 'LinkedIn',
      description: 'Post content directly to LinkedIn',
    },
    'twitter': {
      title: 'X',
      description: 'Post content directly to X',
    }
  },
  'Custom APIs': {
    'contently_api': {
      title: 'Contently API',
      description: 'Contently credentials for custom APIs',
    },
    'zapier': {
      title: 'Zapier',
      description: 'Add API credentials to connect with Zapier',
    },
  },
  'Sales Enablement': {
    'salesforce': {
      title: 'Salesforce',
      description: 'Access your Story Library in Salesforce',
    },  
  },
};

/**
 * React component to list the available Integrations as clickable cards.
 * 
 * @returns React.Component
 */
function IntegrationsList({appData}) {
  const {brandProfilePlatforms, accountId} = JSON.parse(appData);

  const brandProfileHasIntegration = useCallback((platform) => brandProfilePlatforms.includes(platform), [brandProfilePlatforms]);

  return (
    <Fragment>
      {Object.entries(availableIntegrationsByCategory).map( ([category,integrations]) => (
        Object.entries(integrations).map(i => i[0]).filter(brandProfileHasIntegration).length > 0 &&
        <IntegrationCardCategory key={category}>
          <CategoryTitle>
            <CategoryName>{category}</CategoryName>
          </CategoryTitle>
          <IntegrationCardGrid>
            {Object.entries(integrations).map( ([platform, metadata]) => (
              <IntegrationCard key={platform}
                available={brandProfileHasIntegration(platform)}
                platform={platform}
                title={metadata.title}
                description={metadata.description} 
                link={`/organizations/${accountId}/integrations/new?platform=${platform}`} />
            ))}
          </IntegrationCardGrid>
        </IntegrationCardCategory>
      ))}
    </Fragment>
  )
}

IntegrationsList.propTypes = {
  /** JSON from the Ruby side. */
  appData: PropTypes.string.isRequired,
};

export default IntegrationsList;


// WEBPACK FOOTER //
// ./app/javascript/app/components/integrations/IntegrationsList.jsx